import { gql } from '@apollo/client';
import { useMutation } from '@apollo/client/react';

import {
    BulkCancelVisitsMutation,
    BulkCancelVisitsMutationVariables,
} from './useBulkCancelVisits.gql.types';

export const BULK_CANCEL_VISITS_MUTATION = gql`
    mutation BulkCancelVisits($input: BulkCancelVisitsInput!) {
        bulkCancelVisits(input: $input) {
            success
            totalCount
            successCount
            errorCount
            results {
                success
                resource {
                    id
                    state
                    outcome
                }
                errors {
                    message
                }
            }
        }
    }
`;

/**
 * Cancel one or more visits via the GraphQL bulk mutation.
 *
 * Returns Apollo's `[mutate, { loading, ... }]` tuple — use the `loading` flag
 * to disable submission while in flight rather than tracking a separate state;
 * it flips synchronously when the mutation fires and is always reliable. Used
 * by both the single-visit (CancelVisitDialog) and bulk (BulkCancelVisitsDialog)
 * cancel flows.
 */
export const useBulkCancelVisits = () =>
    useMutation<BulkCancelVisitsMutation, BulkCancelVisitsMutationVariables>(
        BULK_CANCEL_VISITS_MUTATION,
    );
